import { useMutation } from '@tanstack/react-query';
import { RestEndpoints } from "../../../api/endpoints";
import getInstance from "../../../utils/rest";
import { IPomAnnouncementExcelExport } from "../../domain/announcements/pom-announcement-export";

const exportExcelAnnouncements = async (exportData: IPomAnnouncementExcelExport): Promise<string> => {
  const { data } = await getInstance().post(RestEndpoints.PomAnnouncementExportExcel, exportData);
  return data;
};

export const useExportExcelAnnouncements = () => {
  return useMutation({

    mutationFn: (exportData: IPomAnnouncementExcelExport) =>
      exportExcelAnnouncements(exportData)
  });
};
